import { Navigate } from "react-router-dom";

const MemberGuard = (props) => {
  const user = localStorage.getItem("rewardClubUser");
  const isLoggedIn = JSON.parse(user);
  return isLoggedIn?.id && isLoggedIn?.role === "member" ? props.children : <Navigate to="/" />
};

export default MemberGuard;
